import { HistoryEntryV2 } from "types";

import { v2ApiClient } from "../apiClient";

interface GetDeviceHistoryOptions {
  tid: string;
  begin: string;
  end: string;
  interval?: string;
}

export const getDeviceHistory = ({ tid, begin, end, interval = "10m" }: GetDeviceHistoryOptions) =>
  v2ApiClient.get<HistoryEntryV2[]>(`/api/v2/device/${encodeURIComponent(tid)}/history`, {
    begin,
    end,
    interval
  });
